import React from 'react'
import type { FadeProps as MuiFadeProps } from '@material-ui/core/Fade'
import MuiFade from '@material-ui/core/Fade'

export type FadeProps = MuiFadeProps

const Fade = React.forwardRef<unknown, FadeProps>(function Fade(props, ref) {
  return <MuiFade ref={ref} {...props} />
})

export default Fade
